module.exports = __webpack_public_path__ + "static/img/26842.2f864d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/ddjy/26842.png
// module id = dBeb
// module chunks = 0